<template>
<v-card>
    <v-slide-y-transition>
        <v-card-title v-if="selected.length > 0">
        <span class="mr-2">Ações em lote:</span>
        <v-btn icon flat small title="Editar" @click="showForm(selected)"><v-icon>edit</v-icon></v-btn>
        <v-btn icon flat small title="Excluir" @click="delData = {func:removeProduct,id:null}">
        <v-icon>delete</v-icon></v-btn>
        <v-btn icon flat small title="Ativar todos" @click="toggleActive(true)"><v-icon>visibility</v-icon></v-btn>
        <v-btn icon flat small title="Desativar todos" @click="toggleActive(false)"><v-icon>visibility_off</v-icon></v-btn>
        <v-btn icon flat small title="Colocar todos em destaque" @click="toggleHighlight(true)"><v-icon>star</v-icon></v-btn>
        <v-btn icon flat small title="Tirar todos de destaque" @click="toggleHighlight(false)"><v-icon>star_outline</v-icon></v-btn>
        <template v-if="!selectAll &&selected.length == pages.rowsPerPage">
            <span>Todos os <b>{{selected.length}}</b> produtos nesta página estão selecionados.</span>
            <v-btn flat color="accent" @click="selectAll = true">
                Selecionar todos os {{products.recordsTotal}} produtos {{(this.typeSelected)?'em '+this.typeSelected.name:''}}
            </v-btn>
        </template>
        <template v-if="selectAll">
            <span>Todos os <b>{{products.recordsTotal}}</b> produtos {{(this.typeSelected)?'em '+this.typeSelected.name:''}} estão selecionados.</span>
            <v-btn flat color="accent" @click="selected = [];selectAll = false">
                Limpar sessão
            </v-btn>
        </template>
        </v-card-title>
    </v-slide-y-transition>
    <v-data-table
    :headers="computedHeaders"
    v-model="selected"
    disable-initial-sort
    :loading="loading"
    :rows-per-page-items="[25,50,100]"
    :items="products.data"
    item-key="_id"
    select-all="accent"
    @update:pagination="setPage"
    :total-items="products.recordsTotal"
    >
        <template v-slot:items="props">
            <tr :active="props.selected" @click="clickRow(()=>props.selected = !props.selected, props.item)">
                <td>
                <v-checkbox
                    :input-value="props.selected"
                    primary
                    hide-details
                ></v-checkbox>
                </td>
                <td class="hidden-sm-and-down">{{ props.item.code }}</td>
                <td>{{ props.item.productname }}</td>
                <td class="hidden-sm-and-down">{{ props.item.description }}</td>
                <td class="hidden-sm-and-down" v-if="!typeSelected">{{ props.item.type }}</td>
                <td class="hidden-sm-and-down">{{ props.item.subtype }}</td>
                <td class="text-xs-right hidden-sm-and-down" v-if="restaurant.service_supplier">{{ (!props.item.sale_without_stock)?props.item.stock:'-' }}</td>
                <td class="text-xs-right hidden-sm-and-down" v-if="restaurant.service_supplier">{{ price(props.item.costs || 0) }}</td>
                <td class="text-xs-right hidden-sm-and-down" v-if="restaurant.service_supplier">{{ props.item.taxes || 0 }}</td>
                <td class="text-xs-right hidden-sm-and-down">{{ price(props.item.price) }}</td>
                <td class="text-xs-center">
                    <v-icon small v-if="props.item.active" color="success">visibility</v-icon>
                    <v-icon small v-else color="error">visibility_off</v-icon>
                </td>
                <td>
                <v-icon
                    small
                    class="mr-2"
                    @click="showForm(props.item)"
                >
                    edit
                </v-icon>
                <v-icon
                    small
                    @click="delData = {func:removeProduct,id:props.item._id}"
                >
                    delete
                </v-icon>
                </td>
            </tr>
        </template>
    </v-data-table>
    <v-dialog v-model="deleteDialog" lazy max-width="250px">
        <v-card>
            <v-card-text class="headline text-xs-center">
                Tem certeza que deseja excluir?
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
            <v-btn
                color="black"
                flat
                @click="deleteDialog = false"
                :disabled="loading"
            >
                Não
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="red"
                flat
                @click="delData.func(delData.id)"
                :loading="loading"
                :disabled="loading"
            >
                Sim
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-card>
</template>

<script>
import {mapGetters} from 'vuex'
import SpProductMobile from '../components/SpProductMobile'
import draggable from 'vuedraggable'

export default {
    components:{
        SpProductMobile,
        draggable
    },
    data(){
        return {
            sheet: false,
            radios:'',
            headers: [
                { text: 'Código', value: 'code', width:"80px", breakpoint:"smAndDown"},
                {
                text: 'Nome',
                align: 'left',
                value: 'productname'
                },
                { text: 'Descrição', value: 'description', breakpoint:"smAndDown"},
                { text: 'Categoria', value: 'type', breakpoint:"smAndDown", typeHeader:true},
                { text: 'Sub-categoria', value: 'subtype', breakpoint:"smAndDown"},
                { text: 'Estoque', value: 'stock', width:"80px", breakpoint:"smAndDown", serviceSupplier: true},
                { text: 'CMV', value: 'costs', width:"80px", breakpoint:"smAndDown", serviceSupplier: true},
                { text: 'Impostos', value: 'taxes', width:"80px", breakpoint:"smAndDown", serviceSupplier: true},
                { text: 'Preço', value: 'price', width:"80px", breakpoint:"smAndDown"},
                { text: 'ativo',align: 'center', value: 'active', width:"45px" },
                { text: 'Ações', value: 'actions', sortable: false, width:"90px" }
            ],
            selected:[],
            loading:false,
            deleteDialog:false,
            delData:{func:null,id:""},
            selectAll:false,
            pages:{},
            clicks: 0,
            timer: null
        }
    },
    watch:{
        delData(v){
            this.deleteDialog = true
        },
        selected(v){
            if(this.selectAll && v.length < this.pages.rowsPerPage){
                this.selectAll = false
            }
        },
        typeSelected(){
            this.selectAll = false
        }
    },
    computed:{
        ...mapGetters([
            'products',
            'typeSelected',
            'restaurant'
        ]),
        computedHeaders(){
            return this.headers.filter(h => {
                if(h.serviceSupplier && !this.restaurant.service_supplier){
                    return false
                }
                if(h.typeHeader)
                    return !this.typeSelected
                return (!h.breakpoint || !this.$vuetify.breakpoint[h.breakpoint])
            })
        }
    },
    methods:{
        clickRow(func,item){
          this.clicks++ 
          if(this.clicks === 1) {
            this.timer = setTimeout(()=>{
                if(this.clicks===1)func()
                this.clicks = 0
            }, 300)
          } else{
            this.showForm(item)  
            this.clicks = 0
          }         
        },
        async setPage(v){
            const data = {page:v.page,limit:v.rowsPerPage}
            data.order_column = v.sortBy || ''
            data.order_dir = (v.descending)?-1:1
            this.$store.commit('SET_PAGINATION',data)
            this.pages = v
            this.loading = true
            await this.$store.dispatch('fetchProducts')
            this.loading = false
        },
        price(v){
            return 'R$' + Number(v).toFixed(2).toString().replace('.',',')
        },
        showMore(){
            let length = this.list.length
            if(length >= 30 && length < this.products.data.length)
                this.list = [...this.list,...this.products.data.slice(length,length+30)]
        },
        showForm(product=null){
            if(this.selectAll){
                this.$store.commit('FETCH_MULTI_PRODUCTS',['*'])
            }else if(Array.isArray(product)){
                this.$store.commit('FETCH_MULTI_PRODUCTS',product)    
            }else{
                this.$store.commit('FETCH_PRODUCT',product)
                this.$store.commit('TOGGLE_PRODUCT_DIALOG')
            }
        },
        async removeProduct(id){
            if(!id){
                if(this.selectAll){
                    id = '*'
                }else{
                    id = this.selected.reduce((acc,curr)=>acc.concat(curr._id),[]).join(";")
                }
            }
            this.loading = true
            await this.$store.dispatch('deleteProduct',id)
            this.loading = false
            this.deleteDialog = false
        },
        async toggleActive(active){
            this.loading = true
            const data = {
                active
            }
            if(this.selectAll){
                data.product_id = '*'
            }else{
                data.product_id = this.selected.reduce((acc,curr)=>acc.concat(curr._id),[]).join(";")
            }
            this.$store.dispatch('alterStatusProducts',data).then(res=>{
                setTimeout(async () => {
                    this.selected = []
                }, 300);
                this.loading = false
            }).catch(err=>{
                this.error = err
                console.log(err)
                this.loading = false
            })
        },
        async toggleHighlight(highlight){
            this.loading = true
            const data = {
                highlight
            }
            if(this.selectAll){
                data.product_id = '*'
            }else{
                data.product_id = this.selected.reduce((acc,curr)=>acc.concat(curr._id),[]).join(";")
            }
            this.$store.dispatch('alterStatusProducts',data).then(res=>{
                setTimeout(async () => {
                    this.selected = []
                }, 300);
                this.loading = false
            }).catch(err=>{
                this.error = err
                console.log(err)
                this.loading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .sp-product-list{
        overflow-y: auto;
        overflow-x: hidden;
    }
    .full-height .flex{
        display: flex;
    }
    .full-height > .card{
        flex: 1 1 auto
    }
    .flexcard {
        display: flex;
        flex-direction: column;
    }
</style>